import React, { useEffect, useState } from 'react'
import { Pencil,  Trash,Eye } from "@phosphor-icons/react";
import LoadImg from "../../Assets/gallery.png";
import ImageLoader from "../loader/ImageLoader.js";
import ManageGuestsImageView from '../Dashboard/ManageGuestsModal/ManageGuestsImageView.jsx';
import useVerificationImages from '../../hooks/useVerificationImages';

export default function ManageRoomGuest(props) {

    const { urls: imgUrls, loading } = useVerificationImages(props?.guest?.verification_id);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [modalOpen,setModalOpen] = useState(false);
    const [modalData, setModalData] = useState({
        img: "",
        name: "",
        phone: "",
        email: "",
        address: "",
    });
    
     



    const activeGuest = ()=>{
        try{
            if(props.buttonDisabled){
                return;
            }

            props.setActiveGuest(props.guestIndex);
            props.setIsFormOpen(true);

        }catch(error){
            console.log(error);
        }
    }

    const deleteGuest = async()=>{
        try{
            if(props.buttonDisabled){
                return;
            }

            const updatedGuests = props.guests.filter((guest,index)=>{
                if (index  === props.guestIndex) { 
                    return false;
                }
                else{
                    return true;
                }
            });
  
            

            // Update the state with the modified guest data
            props.setGuests(updatedGuests);
            props.setActiveGuest(-1);
            props.setIsFormOpen(false);


        }catch(error){
            console.log(error);
        }
    }


    // Reset index if imgUrls change
    useEffect(() => {
        setCurrentIndex(0);
    }, [imgUrls]);

    const goPrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? imgUrls.length - 1 : prev - 1));
    };

    const goNext = () => {
        setCurrentIndex((prev) => (prev === imgUrls.length - 1 ? 0 : prev + 1));
    };




    // Set Up Modal Data
    const setModalInfo = (guest, imgUrl) => {
        setModalData({
            img: imgUrl,
            name: guest?.name || "Name",
            phone: guest?.contact || "Contact",
            email: guest?.email || "Email",
            address: guest?.address || "Address",
        });
        setModalOpen(true);
    };



  return (
    <>
        <div className={`cursor-pointer border border-[#BFC4CC] rounded-lg ${props.guestIndex===props.activeGuest && "border-2 border-[#FF7378]" } `}>
            
            {/* Image Display */}
            {/* {
            (loading) ?  
                <div className='w-full h-[200px] overflow-hidden'> 
                    <ImageLoader/> 
                </div> 
                :
                <div className='w-full h-[200px] overflow-hidden  '>
                    <img src={guestImage|| LoadImg} className='w-full h-full object-cover' alt="Error"/>
                </div>
            } */}

            {/* Images Display — minors don't carry a verification ID */}
            {props?.guest?.is_minor ? (
                <div className="w-full h-[90px] flex flex-col items-center justify-center gap-1 rounded-lg bg-[#FFF8F0] border-b border-dashed border-[#FED7AA]">
                    <span className="text-3xl">🧒</span>
                    <span className="text-xs text-[#9A3412]">No ID required for kids</span>
                </div>
            ) : (
            <div className="w-full h-[200px] relative flex items-center justify-center overflow-hidden rounded-lg bg-gray-100">
                {loading ? (
                    <ImageLoader />
                ) : imgUrls.length > 0 ? (
                    <>
                    <img
                        src={imgUrls[currentIndex]}
                        alt={`Image ${currentIndex + 1}`}
                        className="w-full h-full object-cover rounded-lg "
                    />

                    {/* Prev Button */}
                    <button
                        onClick={goPrev}
                        className="absolute left-1 top-1/2 -translate-y-1/2 bg-black bg-opacity-40 text-white p-2 rounded-full hover:bg-opacity-60"
                    >
                        ◀
                    </button>

                    {/* Next Button */}
                    <button
                        onClick={goNext}
                        className="absolute right-1 top-1/2 -translate-y-1/2 bg-black bg-opacity-40 text-white p-2 rounded-full hover:bg-opacity-60"
                    >
                        ▶
                    </button>

                    {/* Dots */}
                    <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-2">
                        {imgUrls.map((_, i) => (
                        <div
                            key={i}
                            className={`w-2 h-2 rounded-full ${
                            i === currentIndex ? "bg-white" : "bg-gray-400"
                            }`}
                        />
                        ))}
                    </div>
                    </>
                ) : (
                    <img
                    src={LoadImg}
                    alt="Fallback"
                    className="w-full h-full object-cover rounded-lg"
                    />
                )}
            </div>
            )}

            <div className='flex flex-col gap-1 bg-[#EEF0FB] px-2 py-2'>
                <h4 className='text-[#0E0E0E] text-[21px] font-bold flex items-center gap-2'>
                    {props?.guest?.name || "Name"}
                    {props?.guest?.is_minor && (
                        <span className='text-xs font-semibold text-[#9A3412] bg-[#FFEDD5] border border-[#FED7AA] rounded-full px-2 py-0.5'>
                            Kid
                        </span>
                    )}
                </h4>
                {!props?.guest?.is_minor && (
                    <p>
                        +{props?.guest?.contact || "Contact"}
                    </p>
                )}
                <div className='flex ms-auto gap-5 mt-3'>
                    {!props?.guest?.is_minor && (
                        <span className='bg-white border border-[#BFC4CC] rounded-lg p-1'  onClick={()=>setModalInfo(props.guest,imgUrls)}   >
                            <Eye />
                        </span>
                    )}
                    <span className='bg-white border border-[#BFC4CC] rounded-lg p-1'  onClick = {()=>activeGuest()}  disabled={props.buttonDisabled} >
                        <Pencil />
                    </span>
                    <span  className='bg-white border border-[#BFC4CC] rounded-lg p-1' onClick = {()=>deleteGuest()}  disabled={props.buttonDisabled} >
                        <Trash className='text-[#D02746]' />
                    </span>
                </div>
            </div>
        </div>
        <ManageGuestsImageView
            imageOpen={modalOpen}
            setImageOpen={setModalOpen}
            modalData={modalData}
        />
    </>
  )
}
